<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="list"></ng-container>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectprodsize_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <ng-container *ngTemplateOutlet="list"></ng-container>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>

    <p *ngIf="error" role="alert">{{ error }}</p>
</tt-page>

<ng-template #list>
    <ng-container>
        <tt-card>
            <form (ngSubmit)="search()">
                <tt-input ttLabel="prodsize_search" ttType="search" [ttModel]="searchText" (ttModelChange)="changeSearch($event)" ttShowClearButton>
                    <ng-container buttons>
                        <tt-form-field-button ttId="search" [ttIcon]="loading ? 'fas fa-spinner fa-spin' : 'fas fa-search'" [ttDisabled]="loading" (ttClick)="search()"></tt-form-field-button>
                    </ng-container>
                </tt-input>
            </form>
        </tt-card>

        <tt-list [ttData]="items" ttBackStyle [ttGoto]="false" (ttClick)="select($event.item)"></tt-list>
    </ng-container>
</ng-template>
